import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useOutletContext } from "react-router-dom";
import LoginPage from "@/pages/LoginPage";
import DashboardLayout from "@/components/DashboardLayout";
import DashboardPage from "@/pages/DashboardPage";
import InventoryPage from "@/pages/InventoryPage";
import CrewPage from "@/pages/CrewPage";
import EventsPage from "@/pages/EventsPage";
import CalendarPage from "@/pages/CalendarPage";
import TeamPage from "@/pages/TeamPage";

import RevenuePage from "@/pages/RevenuePage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import NotesPage from "@/pages/NotesPage";

// Staff-only pages: crew logins are bounced back to their dashboard even if
// they navigate to the URL directly. The backend enforces this too — this is
// just so crew never see a broken page.
function StaffOnly({ children }) {
  const { role } = useOutletContext() || {};
  if (role === "crew") return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<DashboardLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="inventory" element={<StaffOnly><InventoryPage /></StaffOnly>} />
        <Route path="crew" element={<StaffOnly><CrewPage /></StaffOnly>} />
        <Route path="events" element={<EventsPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="notes" element={<NotesPage />} />
        <Route path="revenue" element={<StaffOnly><RevenuePage /></StaffOnly>} />
        <Route path="team" element={<StaffOnly><TeamPage /></StaffOnly>} />
        <Route path="integrations" element={<StaffOnly><IntegrationsPage /></StaffOnly>} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
